// hooks/useMaintenanceStatus.ts
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  MAINTENANCE_QUERY_KEY,
  fetchMaintenanceStatus,
  updateMaintenance,
  type MaintenanceUpdate,
} from "../services/maintenanceService";
import type { MaintenanceStatus } from "../utils/maintenance";

/**
 * État du mode maintenance. Realtime (useGlobalRealtime) invalide la clé à chaque
 * bascule ; le refetchInterval sert de filet pour les fenêtres programmées
 * (starts_at / ends_at), que le serveur évalue sans émettre d'événement.
 */
export function useMaintenanceStatus(enabled = true) {
  return useQuery<MaintenanceStatus>({
    queryKey: MAINTENANCE_QUERY_KEY,
    queryFn: fetchMaintenanceStatus,
    enabled,
    staleTime: 30 * 1000,
    refetchInterval: 60 * 1000,
    refetchOnWindowFocus: true,
    placeholderData: undefined,
    // Un RPC en échec ne doit pas verrouiller tout le monde dehors : l'app tourne sans.
    retry: 1,
  });
}

export function useUpdateMaintenance() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: MaintenanceUpdate) => updateMaintenance(payload),
    onSuccess: (status) => {
      queryClient.setQueryData(MAINTENANCE_QUERY_KEY, status);
    },
  });
}
